<template>
	<!-- PDV Balcão dedicado: sem navegação, topo, rodapé ou seletor de tema -->
	<div id="app" class="pdv-dedicated-shell" v-if="isLogado && empresa && isPdvDedicado">
		<div class="body-loading" v-if="loadingCount > 0"><span class="loader"></span></div>
		<router-view />
	</div>

	<!-- Sistema principal - usuário logado e empresa selecionada -->
	<div id="app" v-else-if="isLogado && empresa">
		<div class="wrapper">
			<div class="body-loading" v-if="loadingCount > 0">
				<span class="loader"></span>
			</div>

         <!-- Menu Lateral -->
         <Lateral />

			<!-- Menu NavBar -->
			<NavBar />
			
			<!-- Corpo sistema -->
			<div class="page-wrapper">
				<div class="page-content">
					<div id="tab-content">
						<div>
							<ul class="nav nav-header mb-0" v-if="exibirHeaderTabs">
								<li class="nav-item" v-for="(tab, index) in tabsSecaoAtivaPermitidas" :key="index">
								<router-link class="nav-link" :to="tab.path"
									:class="{ active: tab.ativa }"
                                    :aria-current="tab.ativa ? 'page' : null">
									<span>
										<i :class="tab.icon"></i>{{ tab.nome }}
									</span>
								</router-link>
								</li>
							</ul>
						</div>
					</div>

					<div id="main-content" :class="exibirHeaderTabs ? '' : 'main-content2'">
						<router-view :key="empresa ? empresa.id : 'sem-empresa'"/>
					</div>
				</div>

				<a href="javaScript:;" class="back-to-top"><i class='bx bxs-up-arrow-alt'></i></a>
			</div>

			<div class="overlay toggle-icon" @click="toggleMobileMenu"></div>
			
         <!-- Mudar tema -->
         <div class="switcher-wrapper">
            <div class="switcher-btn"><i class='bx bx-cog bx-spin'></i></div>
            <div class="switcher-body">
               <div class="d-flex align-items-center">
                  <h5 class="mb-0 text-uppercase">Tema</h5>
                  <button type="button" class="btn-close ms-auto close-switcher" aria-label="Close"></button>
               </div>
               <hr/>
               <h6 class="mb-0"><i class="far fa-palette color-theme font-13 me-1"></i> Estilo</h6>
               <hr/>
               <div class="row row-cols-2 m-0 align-items-center">
                  <div class="form-check pe-1">
                     <input class="form-check-input" type="radio" name="flexRadioDefault" id="lightmode" :checked="theme == 'light-theme'">
                     <label class="form-check-label ps-1" for="lightmode">Claro</label>
                  </div>
                  <div class="form-check pe-1">
                     <input class="form-check-input" type="radio" name="flexRadioDefault" id="darkmode" :checked="theme == 'dark-theme'">
                     <label class="form-check-label ps-1" for="darkmode">Escuro</label>
                  </div>
               </div>
               <div class="row row-cols-2 m-0 align-items-center">
                  <div class="form-check pe-1">
                     <input class="form-check-input" type="radio" name="flexRadioDefault" id="semidark" :checked="theme == 'semi-dark'">
                     <label class="form-check-label ps-1" for="semidark">Semi Escuro</label>
                  </div>
						<div class="form-check pe-1">
							<input class="form-check-input" type="radio" id="minimaltheme" name="flexRadioDefault" :checked="theme == 'minimal-theme'">
							<label class="form-check-label ps-1" for="minimaltheme">Minimal</label>
						</div>
               </div>
               <hr/>
               <h6 class="mb-0"><i class="far fa-paint-brush color-theme font-13 me-1"></i> Cor</h6>
               <hr/>
               <div class="header-colors-indigators">
                  <div class="row row-cols-auto g-3">
                     <div class="col">
                        <div class="indigator headercolor1" id="headercolor1" title="Azul principal" aria-label="Selecionar paleta azul principal"></div>
                     </div>
                     <div class="col">
                        <div class="indigator headercolor2" id="headercolor2" title="Cinza neutro" aria-label="Selecionar paleta cinza neutro"></div>
                     </div>
                     <!--
                     <div class="col">
                        <div class="indigator headercolor3" id="headercolor3"></div>
                     </div>
                     -->
                     <div class="col">
                        <div class="indigator headercolor4" id="headercolor4" title="Verde principal" aria-label="Selecionar paleta verde principal"></div>
                     </div>
                     <div class="col">
                        <div class="indigator headercolor5" id="headercolor5"></div>
                     </div>
                     <div class="col">
                        <div class="indigator headercolor6" id="headercolor6"></div>
                     </div>
                     <div class="col">
                        <div class="indigator headercolor7" id="headercolor7"></div>
                     </div>
                     <div class="col">
                        <div class="indigator headercolor8" id="headercolor8"></div>
                     </div>
                     <div class="col">
                        <div class="indigator headercolor9" id="headercolor9" title="Azul royal" aria-label="Selecionar paleta azul royal"></div>
                     </div>
                     <div class="col">
                        <div class="indigator headercolor10" id="headercolor10" title="Azul oceano" aria-label="Selecionar paleta azul oceano"></div>
                     </div>
                     <div class="col">
                        <div class="indigator headercolor11" id="headercolor11" title="Azul aço" aria-label="Selecionar paleta azul aço"></div>
                     </div>
                     <div class="col">
                        <div class="indigator headercolor12" id="headercolor12" title="Verde esmeralda" aria-label="Selecionar paleta verde esmeralda"></div>
                     </div>
                     <div class="col">
                        <div class="indigator headercolor13" id="headercolor13" title="Verde floresta" aria-label="Selecionar paleta verde floresta"></div>
                     </div>
                     <div class="col">
                        <div class="indigator headercolor14" id="headercolor14" title="Verde oliva" aria-label="Selecionar paleta verde oliva"></div>
                     </div>
                     <div class="col">
                        <div class="indigator headercolor15" id="headercolor15" title="Escalador — azul-petróleo com acento laranja" aria-label="Selecionar paleta inspirada na logo Escalador"></div>
                     </div>
                     <div class="col">
                        <div class="indigator headercolor16" id="headercolor16" title="Azul marinho" aria-label="Selecionar paleta azul marinho"></div>
                     </div>
                     <div class="col">
                        <div class="indigator headercolor17" id="headercolor17" title="Azul cobalto" aria-label="Selecionar paleta azul cobalto"></div>
                     </div>
                     <div class="col">
                        <div class="indigator headercolor18" id="headercolor18" title="Azul céu sóbrio" aria-label="Selecionar paleta azul céu sóbrio"></div>
                     </div>
                     <div class="col">
                        <div class="indigator headercolor19" id="headercolor19" title="Turquesa profundo" aria-label="Selecionar paleta turquesa profundo"></div>
                     </div>
                     <div class="col">
                        <div class="indigator headercolor20" id="headercolor20" title="Verde jade" aria-label="Selecionar paleta verde jade"></div>
                     </div>
                     <div class="col">
                        <div class="indigator headercolor21" id="headercolor21" title="Verde pinho" aria-label="Selecionar paleta verde pinho"></div>
                     </div>
                     <div class="col">
                        <div class="indigator headercolor22" id="headercolor22" title="Verde sálvia" aria-label="Selecionar paleta verde sálvia"></div>
                     </div>
                     <div class="col">
                        <div class="indigator headercolor23" id="headercolor23" title="Laranja Escalador" aria-label="Selecionar paleta laranja inspirada na logo Escalador"></div>
                     </div>
                     <div class="col">
                        <div class="indigator headercolor24" id="headercolor24" title="Grafite azulado" aria-label="Selecionar paleta grafite azulado"></div>
                     </div>
                     <div class="w-100 theme-palette-label">Combinações do azul principal</div>
                     <div class="col">
                        <div class="indigator headercolor25" id="headercolor25" title="Azul principal + ciano" aria-label="Selecionar paleta azul principal com ciano"></div>
                     </div>
                     <div class="col">
                        <div class="indigator headercolor26" id="headercolor26" title="Azul principal + esmeralda" aria-label="Selecionar paleta azul principal com esmeralda"></div>
                     </div>
                     <div class="col">
                        <div class="indigator headercolor27" id="headercolor27" title="Azul principal + âmbar" aria-label="Selecionar paleta azul principal com âmbar"></div>
                     </div>
                     <div class="col">
                        <div class="indigator headercolor28" id="headercolor28" title="Azul principal + violeta" aria-label="Selecionar paleta azul principal com violeta"></div>
                     </div>
                     <div class="col">
                        <div class="indigator headercolor29" id="headercolor29" title="Azul principal + coral" aria-label="Selecionar paleta azul principal com coral"></div>
                     </div>
                     <div class="col">
                        <div class="indigator headercolor30" id="headercolor30" title="Azul principal + rosa" aria-label="Selecionar paleta azul principal com rosa"></div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
		</div>
	</div>

	<!-- Portal público de orçamento -->
	<div id="app" class="logout bg-login" v-else-if="isPortalPublico">
		<div class="body-loading" v-if="loadingCount > 0">
			<span class="loader"></span>
		</div>
		<router-view />
	</div>

	<!-- Seleção de Empresa - usuário logado mas sem empresa selecionada -->
	<div id="app" class="logout bg-login" v-else-if="isLogado && !empresa">
		<!-- Page Loader -->
		<div class="body-loading" v-if="loadingCount > 0">
			<span class="loader"></span>
		</div>

		<router-view />
	</div>

	<!-- Login - usuário não logado -->
	<div id="app" class="logout bg-login" v-else>
		<!-- Page Loader -->
		<div class="body-loading" v-if="loadingCount > 0">
			<span class="loader"></span>
		</div>

		<Login />
	</div>
</template>

<script>

import Vue from 'vue'
import $ from 'jquery'
// import Swal from 'sweetalert2'
import { mapState } from 'vuex'
import Login from '@/views/Login.vue'
import NavBar from '@/components/MenuNavBar.vue'
import Lateral from '@/components/MenuLateral.vue'

export default {
	name: 'App',
	data: function() {
		return {
         themeColor: (localStorage.jair_theme_color == null ? 'color-header headercolor1' : 'color-header '+ localStorage.jair_theme_color),
         theme: (localStorage.jair_theme == null ? 'semi-dark' : localStorage.jair_theme),
          telasResumo: ['Resumo_notas_fiscais', 'Resumo_solicitações', 'Resumo_estoque'],
          telasListagem: ['Lista_notas_fiscais', 'Lista_solicitações', 'Lista_estoques'],
          telasVisualizacao: ['Cotação', 'Nota_fiscal', 'Comparação'],
          ocultarHeaderTabs: false,
          rotaInicialPendente: null
		}
	},
	computed: {
		... mapState({
			loadingCount: state => state.loadingCount,
			isLogado: state => state.isLogado,
			empresa: state => state.empresa,
			secaoAtiva: state => state.secaoAtiva,
			secoes: state => state.secoes
		}),
		tabsSecaoAtiva() {
			return this.secoes[this.secaoAtiva] ? this.secoes[this.secaoAtiva].tabs : [];
		},
		tabsSecaoAtivaPermitidas() {
			return this.tabsSecaoAtiva
				.map((tab, index) => ({ ...tab, originalIndex: index }))
				.filter(tab => this.temPermissaoRota(tab.path))
		},
		exibirHeaderTabs() {
            return (this.tabsSecaoAtivaPermitidas.length > 1 || (this.tabsSecaoAtivaPermitidas.length === 1 && this.secoes[this.secaoAtiva]?.showSingleTab)) && !this.ocultarHeaderTabs
		},
		isPortalPublico() {
			return this.$route && this.$route.path && (this.$route.path.startsWith('/portal/orcamento/') || this.$route.path.startsWith('/portal/pedido-compra/'))
		},
		isPdvDedicado() {
			return this.normalizarPath(this.$route?.path) === '/pdv'
		}
	},
	watch: {
		$route(to) {
			if (to && to.path && (to.path.startsWith('/portal/orcamento/') || to.path.startsWith('/portal/pedido-compra/'))) {
				return
			}
			const rotaControlaModoFormulario = to && to.path && (to.path.startsWith('/fiscal/') || to.path.startsWith('/comercial/pedido') || to.path.startsWith('/comercial/condicional'))
			if (!rotaControlaModoFormulario) {
				this.definirVisibilidadeHeaderTabs(false)
			}
			this.sincronizarSecaoEAbaPorRota(to.path)
		},
		isLogado : function () {
			if (this.isPortalPublico) {
				return
			}
			this.configJs()
			// Se deslogou, garantir que está na rota correta
			if (!this.isLogado && this.$router.currentRoute.path !== '/' && !this.isPortalPublico) {
				this.$router.push('/')
			}
		},
		empresa : function (novaEmpresa) {
			// Se empresa foi selecionada e está na tela de seleção, redirecionar
			if (novaEmpresa && this.$router.currentRoute.path === '/selecaoEmpresa') {
				this.$router.push('/paginaInicial').catch(() => {})
			}
			// Se empresa foi removida e está logado, voltar para seleção
			if (!novaEmpresa && this.isLogado && this.$router.currentRoute.path !== '/selecaoEmpresa' && this.$router.currentRoute.path !== '/gerencial') {
				this.$router.push('/selecaoEmpresa').catch(() => {})
			}
			// Quando empresa é selecionada, garantir que os eventos do tema sejam configurados
			if (novaEmpresa && this.isLogado) {
				this.configJs()
				this.aplicarRotaInicialPendente()
			}
		}
	},
	components: {
		NavBar, Login, Lateral
	},
	methods: {
		normalizarPath(path) {
			const valor = String(path || '').split('?')[0].replace(/\/+$/, '')
			return (valor || '/').toLowerCase()
		},
		rotaCombina(pathTab, pathAtual) {
			const tab = this.normalizarPath(pathTab)
			const atual = this.normalizarPath(pathAtual)
			return atual === tab || (tab !== '/' && atual.startsWith(`${tab}/`))
		},
		aplicarRotaInicialPendente() {
			if (!this.rotaInicialPendente || !this.isLogado || !this.empresa) return
			const destino = this.rotaInicialPendente
			this.rotaInicialPendente = null
			setTimeout(() => {
				if (this.$route.path !== destino) {
					this.$router.push(destino).catch(() => {})
				}
			}, 80)
		},
		sincronizarSecaoEAbaPorRota(path) {
			if (!path || !this.secoes) return
			const secaoEncontrada = Object.keys(this.secoes).find((secao) => {
				const tabs = this.secoes[secao] ? this.secoes[secao].tabs : []
				return Array.isArray(tabs) && tabs.some((tab) => this.rotaCombina(tab.path, path))
			})
			if (!secaoEncontrada) return
			const tabs = this.secoes[secaoEncontrada].tabs || []
			let tabIndex = tabs.findIndex((tab) => this.normalizarPath(tab.path) === this.normalizarPath(path))
			if (tabIndex < 0) {
				tabIndex = tabs.findIndex((tab) => this.rotaCombina(tab.path, path))
			}
			if (this.secaoAtiva !== secaoEncontrada) {
				this.$store.dispatch('setSecaoAtiva', secaoEncontrada)
			}
			if (tabIndex >= 0) {
				this.$store.dispatch('ativarTab', { secao: secaoEncontrada, tabIndex })
			}
		},
		temPermissaoRota(path) {
			const route = this.$router.options.routes.find(r => r.path === path || r.redirect === path);
			if (!route || !route.meta || !route.meta.role) return true;
			
			const user = this.$store.state.dadosUsuario;
			if (!user) return false;
			
			const roles = user.roles || [];
			const modules = user.modules || [];
			
			const empresa = this.empresa || this.$store.state.empresa;
			const planRoles = (empresa && Array.isArray(empresa.planRoles) && empresa.planRoles.length > 0)
				? empresa.planRoles
				: null;

			const requiredRoles = [].concat(route.meta.role);
			if (planRoles && !requiredRoles.some(role => planRoles.includes(role))) {
				return false;
			}

			return requiredRoles.some(role => roles.includes(role)) || modules.includes('COMPANY_ADMIN');
		},
		ativarTabSecao : function (tabIndex) {
			this.$store.dispatch('ativarTab', { secao: this.secaoAtiva, tabIndex })
		},
		definirVisibilidadeHeaderTabs(ocultar) {
			const modoFormulario = !!ocultar
			this.ocultarHeaderTabs = modoFormulario
			if (typeof document !== 'undefined' && document.body) {
				document.body.classList.toggle('app-operational-form-mode', modoFormulario)
			}
		},
		toggleMobileMenu : function () {
			const minimizada = !$(".wrapper").hasClass("toggled");
			const $wrapper = $(".wrapper");
			const $sidebar = $(".sidebar-wrapper");
			localStorage.setItem('jair_sidebar_collapsed', minimizada ? '1' : '0');
			$sidebar.off("mouseenter.sidebar-state mouseleave.sidebar-state");
			if (minimizada) {
				$wrapper.addClass("toggled");
				$sidebar.on("mouseenter.sidebar-state", function () {
					$wrapper.addClass("sidebar-hovered");
				});
				$sidebar.on("mouseleave.sidebar-state", function () {
					$wrapper.removeClass("sidebar-hovered");
				});
				return;
			}
			$wrapper.removeClass("toggled sidebar-hovered");
		},
		verificarAutoLogin: function () {
			// Tentar fazer login automático se houver credenciais salvas
			this.$store.dispatch('verificarAutoLogin')
		},
		configJs : function () {
			Vue.nextTick(function() {
				$(window).off("scroll").on("scroll", function () {
					if ($(this).scrollTop() > 300) {
						$('.back-to-top').fadeIn();
					} else {
						$('.back-to-top').fadeOut();
					}
				});
		
				$('.back-to-top').off("click").on("click", function () {
					$("html, body").animate({
						scrollTop: 0
					}, 600);
					return false;
				});
		
				$(".switcher-btn").off("click").on("click", function () {
					$(".switcher-wrapper").toggleClass("switcher-toggled");
				});
				$(".close-switcher").off("click").on("click", function () {
					$(".switcher-wrapper").removeClass("switcher-toggled");
				});
            $("#lightmode").off("click").on("click", function () {
					localStorage.jair_theme = 'light-theme';
					$('html').addClass('light-theme');
					$('html').removeClass('dark-theme semi-dark minimal-theme');
					this.theme = 'light-theme';
				}.bind(this));
				$("#darkmode").off("click").on("click", function () {
					localStorage.jair_theme = 'dark-theme';
					$('html').addClass('dark-theme');
					$('html').removeClass('light-theme semi-dark minimal-theme');
					this.theme = 'dark-theme';
				}.bind(this));
				$("#semidark").off("click").on("click", function () {
					localStorage.jair_theme = 'semi-dark';
					$('html').addClass('semi-dark');
					$('html').removeClass('light-theme dark-theme minimal-theme');
					this.theme = 'semi-dark';
				}.bind(this));
				$("#minimaltheme").off("click").on("click", function () {
					localStorage.jair_theme = 'minimal-theme';
					$('html').addClass('minimal-theme');
					$('html').removeClass('light-theme dark-theme semi-dark');
					this.theme = 'minimal-theme';
				}.bind(this));
			const coresTema = Array.from({ length: 30 }, (_, indice) => `headercolor${indice + 1}`)
			coresTema.forEach((cor) => {
				$(`#${cor}`).off("click").on("click", function () {
					localStorage.jair_theme_color = cor
					$("html").removeClass(coresTema.join(' ')).addClass(`color-header ${cor}`)
					this.themeColor = `color-header ${cor}`
				}.bind(this))
			})
			}.bind(this));
		}
	},
	mounted() {
		this.$axios.interceptors.response.use((response) => {
			return response;

		}, (error) => {
			if (error.response == undefined) {
				this.$toast.fire({ icon: 'error', title: error })
			}

			return Promise.reject(error);
		});

		$("html").attr("class", this.theme +' '+ this.themeColor)
		const rotaInicialNavegador = window.location && window.location.pathname ? window.location.pathname : ''
		const queryParams = new URLSearchParams(window.location && window.location.search ? window.location.search : '')
		const portalToken = queryParams.get('portalToken')
		
		if (queryParams.get('abrir') === 'tutoriais') {
			this.rotaInicialPendente = '/tutoriais'
		}

		const explicitRoute = queryParams.get('route')
		const lastPdv = sessionStorage.getItem('last_pdv_route')
		if (explicitRoute) {
			this.rotaInicialPendente = explicitRoute
		} else if (lastPdv) {
			this.rotaInicialPendente = lastPdv
		}

		if (!this.isLogado) {
			if (portalToken) {
				this.$router.replace(`/portal/orcamento/${portalToken}`).catch(() => {})
				return
			}
		}
		if (rotaInicialNavegador.startsWith('/portal/orcamento/')) {
			this.$router.replace(rotaInicialNavegador).catch(() => {})
			return
		}
		// Verificar se há credenciais salvas para auto-login
		this.verificarAutoLogin()
		this.configJs()
		this.sincronizarSecaoEAbaPorRota(this.$route.path)
		this.aplicarRotaInicialPendente()
		this.$root.$on('fiscal-form-mode-change', this.definirVisibilidadeHeaderTabs)
	},
	beforeDestroy() {
		this.$root.$off('fiscal-form-mode-change', this.definirVisibilidadeHeaderTabs)
		this.definirVisibilidadeHeaderTabs(false)
	}
}

</script>
